import { Component, Input, OnInit } from '@angular/core';

import { CasinoManager } from '@casinocore/platform/core';

@Component({
    selector: 'cc-instagram-promo-image',
    templateUrl: 'instagram-promo-image.component.html',
    standalone: true,
})
export class InstagramPromoImageComponent implements OnInit {
    @Input() storyData: any;

    defaultSrc: string;
    constructor(private casinoManager: CasinoManager) {}
    ngOnInit() {
        this.defaultSrc = this.casinoManager.getGrayImageUrl();
    }
    onGameIconError(storyData: any): void {
        storyData.instaPromoImageModel.src = this.defaultSrc;
    }
}
